export default {
  "path": "/demo/tag-group-index",
  "meta": {
    "name": "demo-标签组",
    "title": "TagGroup 标签组",
    "isComponentDoc": true,
    "category": "Data"
  }
};